module.exports = __webpack_public_path__ + "static/taiao-ea11ba5dd98121e4a6309fa589358938.png";